import { tabStore } from '@/features/tabs';
import { uiStore } from '@/stores/ui.store';

export const chromelessWindow = () =>
  !tabStore.showTabBar && uiStore.chromeless;
